export default __webpack_public_path__ + "static/investment-hero-background-lakes-55c08002b9f4c415e416f3d2dc28121a.jpg";